import WaybillsTableColumnInvoices from './index.vue'
export default WaybillsTableColumnInvoices